import { ArrowsAltOutlined, ShrinkOutlined, EnvironmentOutlined, EnvironmentFilled } from '@ant-design/icons'
import { StoreDetailProducts } from '@components/StoreMonitoring/StoreDetailsPage/StoreDetailProducts'
import { Col, Row } from 'antd'
import { useMemo, useState } from 'react'
import { useDestinationsContext } from '../../../Contexts/DestinationsContext'
import { Vertical, Texto } from '@gravitate-js/excalibrr'

export const TankImpactRows = ({ affectedTanks, storeList, rundownToggled }) => {
  const { orderDestinations } = useDestinationsContext()
  if (affectedTanks) {
    return (
      <Vertical flex={1} className='tank-impact-rows'>
        {orderDestinations.map((store) => {
          return (
            <StoreTankRows
              key={store?.key}
              store={store}
              storeList={storeList}
              affectedTanks={affectedTanks}
              rundownToggled={rundownToggled}
            />
          )
        })}
      </Vertical>
    )
  } else return <></>
}

const StoreTankRows = ({ store, affectedTanks, rundownToggled }) => {
  const [showAll, setShowAll] = useState(false)
  const { selectedManifold, setSelectedManifold, selectedTank, setSelectedTank } = useDestinationsContext()

  const affectedStore = useMemo(
    () => affectedTanks.find((tankGroup) => tankGroup.store.toLowerCase() === store.store_number.toLowerCase()),
    [affectedTanks]
  )

  const visibleTankIds = useMemo(
    () =>
      showAll
        ? store.grouped_tanks.flatMap((group) => group.tanks?.map((tank) => tank.tank_id))
        : (affectedStore?.tanks?.map((tank) => tank.tank_id) ?? []),
    [showAll, affectedStore, store]
  )

  if (!affectedStore) return null

  return (
    <>
      <DataSectionValueHeader title={store.store_number} showAll={showAll} setShowAll={setShowAll} />
      <StoreDetailProducts
        rundownToggled={rundownToggled}
        selectedManifold={selectedManifold}
        setSelectedManifold={setSelectedManifold}
        store={store}
        selectedTank={selectedTank}
        setSelectedTank={setSelectedTank}
        visibleTankIds={visibleTankIds}
      />
    </>
  )
}

const DataSectionValueHeader = ({ title, showAll, setShowAll }) => {
  return (
    <div style={{ border: 'solid 1px var(--gray-200)' }} className='detail-section-header p-3' span={24}>
      <Row>
        <Col span={12} className='detail-section-value'>
          <Texto weight='bold' category='h5'>
            <EnvironmentFilled className='pr-1' /> {title}
          </Texto>
        </Col>
        <Col span={12} className='show-all-tanks-toggle pr-2' align='right'>
          {showAll ? (
            <div className='toggle-tanks' onClick={() => setShowAll(false)}>
              <ShrinkOutlined className='pr-2' />
              <span>Show Impacted Tanks</span>
            </div>
          ) : (
            <div className='toggle-tanks' onClick={() => setShowAll(true)}>
              <ArrowsAltOutlined className='pr-2' />
              <span>Show All Tanks</span>
            </div>
          )}
        </Col>
      </Row>
    </div>
  )
}
